import axios from "axios";
import { API_URL } from "../../constants/config";

export const getCertificates = async (learnerId, userUuid, accessToken, products, eportfolioToken = null) => {
  let data = JSON.stringify({
    learner_id: learnerId,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${API_URL}/api/v1/get_certificates`,
    headers: {
      "Content-Type": "application/json",
      Authorization: null,
      "Access-Token": `${accessToken}`,
    },
    data: data,
  };
  try {

    // Check Mykademy exists
    const mykademyProducts = products.filter((product) => {
        return product.sp_slug === "mykademy";
    });

    let mykademyCertData = [];

    if(mykademyProducts.length > 0) {
      const mykademyCert = await axios.request(config);
      mykademyCertData = mykademyCert?.data?.data;
    }

    // Check Eportfolio exists
    let api_url;

    products.forEach((value) => {
      if (value.sp_slug === "eportfolio") {
        api_url = value.api_url;
      }
    });

    if (api_url === undefined) {
      return [...mykademyCertData];
    } else {
      try {
        
        const token = eportfolioToken;

        if (!token) {
          return [...mykademyCertData];
        }

        const apiToken = token;

        let myportfolioConfig = {
          method: "post",
          maxBodyLength: Infinity,
          url: `${api_url}api/v1/completedMemberPrograms/get`,
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${apiToken}`,
          },
          data: {
            user_uuid: userUuid,
          },
        };
        try {
          const eporfolioCert = await axios.request(myportfolioConfig);

          if(eporfolioCert.data.status === 404) {
            return [...mykademyCertData];
          }

          const eporfolioCertData = eporfolioCert?.data?.data?.certificates;

          const modifiedEporfolioCertData = eporfolioCertData.map((item) => ({
            course_title: item.program_name,
            certificate_url: item.certificate_thumbnail_url,
            issued_date: item.certificate_release_date,
          }));

          const mergedData = [
            ...mykademyCertData,
            ...modifiedEporfolioCertData,
          ];
          return mergedData;
        } catch (err) {
          return [...mykademyCertData];
        }
      } catch (err) {
        console.log(err);
        return [...mykademyCertData];
      }
    }
  } catch (err) {
    console.log(err);
    return [];
  }
};
